export default "__VITE_ASSET__2c1c01e1__"